import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const links = [
    { to: '/integrations', label: 'Overview', exact: true },
    { to: '/integrations/list', label: 'All Integrators' },
    { to: '/integrations/webhooks', label: 'Webhook Health' },
    { to: '/integrations/logs', label: 'Logs' },
    { to: '/integrations/sync', label: 'Sync' },
    { to: '/integrations/quotas', label: 'Quotas' },
];

const AdminIntegrationsSubnav = () => (
    <Wrap>
        {links.map((link) => (
            <SubNavLink
                key={link.to}
                to={link.to}
                end={Boolean(link.exact)}
            >
                {link.label}
            </SubNavLink>
        ))}
    </Wrap>
);

export default AdminIntegrationsSubnav;

const Wrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
    padding: 0.625rem;
    border: 1px solid ${({ theme }) => theme.colors.border};
    background: ${({ theme }) => theme.colors.surface};
    border-radius: 12px;
`;

const SubNavLink = styled(NavLink)`
    text-decoration: none;
    color: ${({ theme }) => theme.colors.textPrimary};
    border: 1px solid ${({ theme }) => theme.colors.border};
    background: ${({ theme }) => theme.colors.surfaceAlt || theme.colors.surface};
    border-radius: 999px;
    padding: 0.4375rem 0.6875rem;
    font-size: 0.8125rem;
    font-weight: 600;
    transition: all 0.15s ease;

    &:hover {
        border-color: var(--color-primary-bg-soft);
        color: var(--color-primary);
        background: var(--color-primary-bg);
    }

    &.active {
        border-color: var(--color-primary);
        background: var(--color-primary-bg);
        color: var(--color-primary);
    }
`;
